export const ErrorStateImage = () => {
	return (
		<svg
			width="172"
			height="172"
			viewBox="0 0 172 172"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M157.683 90.8097H151.222L148.114 82.979H130.607C130.882 66.786 132.534 51.7876 135.498 38.2715H50.5241C50.2739 40.7233 50.0487 43.2063 49.8361 45.7019H25.337L28.4455 53.5388H59.4118L62.5203 61.3758H48.7666C48.7666 61.4758 48.754 61.5759 48.7478 61.676L48.629 61.3758H11.208L14.3165 69.2127H25.3433L28.4518 77.0497H48.2287C48.1599 80.4271 48.1223 83.8233 48.1223 87.2571C48.1223 98.4965 48.4663 109.379 49.1231 119.912H34.3748L37.4834 127.749H28.1328L31.2413 135.586H135.286C133.828 128.819 132.709 121.682 131.921 114.202H118.311L115.202 106.365H126.073L122.964 98.5278L160.798 98.6404L157.689 90.8034L157.683 90.8097Z"
				fill="#4B4D51"
			/>
			<path
				d="M90.9157 76.9185C81.4838 76.9185 75.9798 80.6462 72.8213 86.0188C75.9798 91.3915 81.4901 95.1192 90.9157 95.1192V76.9247V76.9185Z"
				fill="#101214"
			/>
			<path
				d="M90.916 95.1192C100.348 95.1192 105.852 91.3915 109.01 86.0188C105.852 80.6462 100.342 76.9185 90.916 76.9185V95.1129V95.1192Z"
				fill="#101214"
			/>
			<path
				d="M97.4017 87.4699C97.483 87.0196 97.5268 86.538 97.5268 86.0314C97.5268 85.5247 97.483 85.0306 97.4017 84.5741C96.9139 81.8533 95.0187 80.1709 92.3668 79.7393C91.9165 79.6642 91.4411 79.6267 90.947 79.6267C90.4529 79.6267 89.94 79.6705 89.4647 79.7455C86.8128 80.1896 84.9239 81.8596 84.4298 84.5678C84.3485 85.0244 84.3047 85.5122 84.3047 86.0251C84.3047 86.538 84.3485 87.0133 84.4298 87.4637C84.9176 90.1656 86.8065 91.8418 89.4647 92.2859C89.9338 92.3672 90.4279 92.4048 90.947 92.4048C91.4661 92.4048 91.9165 92.3672 92.3668 92.2922C95.025 91.8606 96.9139 90.1781 97.4017 87.4574V87.4699Z"
				fill="#4B4D51"
			/>
			<path
				d="M104.951 71.9834L76.8809 100.054"
				stroke="#101214"
				strokeWidth="3.7152"
				strokeMiterlimit="10"
			/>
			<path d="M48.2227 77.0498H66.2483L63.1397 69.2129H48.2227V77.0498Z" fill="#7E8188" />
			<path d="M50.6807 135.592H68.7063L65.5978 127.749H50.124L50.6807 135.592Z" fill="#7E8188" />
			<path d="M130.15 90.7034H118.717L121.825 98.5466H124.69H130.15V90.7034Z" fill="#7E8188" />
		</svg>
	);
};
